import React          from 'react';
import { Meteor }	  from 'meteor/meteor';
import connectField   from 'uniforms/connectField';

import GoogleMapLoader from 'react-google-maps-loader';
import GooglePlacesSuggest from 'react-google-places-suggest';

const MY_API_KEY = "AIzaSyBMHkygr3-56LBRNrjiQI53xDU6G7LLptY";
class GoogleMapsField extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			search: props.value,
			selectedCoordinate: null
		};

	}

	handleSearchChange (e) {
		if(e.target.value != this.state.search)
			this.setState({search: e.target.value});
	}

	handleSelectSuggest(suggest, coordinate) {
		this.setState({search: suggest.description, selectedCoordinate: coordinate});
		this.props.onChange(suggest.description);
	}


	render() {
		const {search} = this.state;
		const {googleMaps} = this.props;

		if(googleMaps) {

		return (
			<GooglePlacesSuggest
				googleMaps={googleMaps}
				onSelectSuggest={this.handleSelectSuggest.bind(this)}
				search={search} >

				<label className="control-label">
					{this.props.label}&nbsp;
				</label>

				<input
					type="text"
					autoComplete="off"
	      			value={search}
	      			placeholder="Recherche..."
	      			ref={this.props.inputRef}
					id={this.props.id}
					name={this.props.name}
	      			onChange={this.handleSearchChange.bind(this)}
	      			className="input-fullwidth"/>

		 	</GooglePlacesSuggest>
		);
	} else {
		return (
			<p>Chargement...</p>
		);
	}

	}

}

export default connectField(GoogleMapLoader(GoogleMapsField, {
	libraries: ["places"],
	key: MY_API_KEY,
}), {includeInChain: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/googleMapsField.js
 **/